import { useOutletContext } from "react-router"
import { AutomationSchedulesList } from "../../../../Automations/Schedules"
import { TAutomation } from "../../../../Automations/store"
import { Helmet } from "react-helmet-async"

export default function AutomationSchedulesPage() {
	const context = useOutletContext<{
		automationId: string
		automation: TAutomation
	}>()

	return (
		<>
			<Helmet>
				<title>Schedules | Automation Details</title>
			</Helmet>
			<AutomationSchedulesList
				automationIds={[Number(context.automationId)]}
				title="Schedules"
			/>
		</>
	)
}
